import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const RefferalsDataGraph = ({ refferalsDataGraph }) => {
  // Fallback for invalid data
  if (!Array.isArray(refferalsDataGraph) || refferalsDataGraph.length === 0) {
    return <div className="text-center text-gray-500">No data available</div>;
  }

  const metrics = ["Referral Prospects",  "Optys Created", "Retail Count",];
  const labels = metrics;

  const categoryColors = {
    "D+30 PSF": "#5b9bd5",
    "D+90 Quality Survey": "#ed7d31",
  };

  const datasets = refferalsDataGraph
    .map((category, index) => {
      // Enhanced validation: check for non-null object with keys
      if (!category || 
          typeof category !== "object" || 
          Object.keys(category).length === 0 || 
          !category.key) {
        return null;
      }

      const values = [
        Number(category.referral_prospects?.value ?? 0),
        Number(category.optys_created?.value ?? 0),
        Number(category.retail_count?.doc_count ?? 0),
      ];

      const color = categoryColors[category.key] || "#5b9bd5";

      return {
        label: String(category.key),
        data: values,
        backgroundColor: color,
        borderColor: color,
        borderWidth: 1,
      };
    })
    .filter(Boolean); // Remove nulls

  if (datasets.length === 0) {
    return <div className="text-center text-gray-500">No valid data to display</div>;
  }

  const data = { labels, datasets };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: { display: true, text: "Referrals Data by Category", font: { size: 16 } },
      legend: { display: true, position: "top" },
      tooltip: { callbacks: { label: (ctx) => `Value: ${ctx.raw}` } },
    },
    scales: {
      y: {
        beginAtZero: true,
        suggestedMax:
          Math.max(
            0,
            ...refferalsDataGraph
              .filter(c => c && typeof c === 'object' && Object.keys(c).length > 0)
              .flatMap((c) => [
                Number(c?.referral_prospects?.value ?? 0),
                Number(c?.retail_count?.doc_count ?? 0),
                Number(c?.optys_created?.value ?? 0),
              ])
          ) + 1,
        grid: { display: false },
        ticks: { precision: 0 },
      },
      x: { grid: { display: false } },
    },
  };

  return (
    <div style={{ height: "300px", width: "500px" }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default RefferalsDataGraph;